import * as generalActions from '../GENERAL/actions';
import * as activeFeedcActions from '../activeFeed/actions';
import * as lawsActions from './actions';
import * as userActions from '../user/actions';
import * as lawsFiltersActions from '../lawsWaitingFilters/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    limit: 10,
    offset: 0,
    hasMore: true,
    count: 0,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsWaitingReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsActions.SET_LAWS_WAITING_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsActions.SET_LAWS_WAITING_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsActions.SET_LAWS_WAITING:
            const mappedList =
                Array.isArray(action.list) && action.list.length
                    ? action.list.map((item) => ({ ...item, importanceChanged: false }))
                    : [];
            const list = state.list ? state.list.concat(mappedList) : mappedList;
            return {
                ...state,
                list: list,
                offset: action.offset,
                hasMore: action.hasMore,
                count: action.count,
                isFetching: false,
                isLoaded: true,
            };

        // Search
        case lawsFiltersActions.LAWS_WAITING_APPLY_SEARCH_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_SEARCH_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_SEARCH_ITEM:
            return initialState;

        // Categories
        case lawsFiltersActions.LAWS_WAITING_APPLY_CATEGORIES_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_CATEGORY_FROM_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_CATEGORIES_FILTER:
            return initialState;

        // Themes
        case lawsFiltersActions.LAWS_WAITING_APPLY_THEMES_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_THEME_FROM_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_THEMES_FILTER:
            return initialState;

        // Dates
        case lawsFiltersActions.LAWS_WAITING_APPLY_DATES_RANGE_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_DATES_RANGE_FILTER:
            return initialState;

        // Documet types
        case lawsFiltersActions.LAWS_WAITING_APPLY_DOCUMENT_TYPE_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FROM_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_DOCUMENT_TYPE_FILTER:
            return initialState;

        // Sources
        case lawsFiltersActions.LAWS_WAITING_APPLY_SOURCES_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_SOURCE_FROM_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_SOURCES_FILTER:
            return initialState;

        // Groups
        case lawsFiltersActions.LAWS_WAITING_APPLY_GROUPS_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_GROUP_FROM_FILTER:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_REMOVE_GROUPS_FILTER:
            return initialState;

        // Importance
        case lawsFiltersActions.LAWS_WAITING_CHANGE_IMPORTANCE_FILTER:
            return initialState;

        // Sort
        case lawsFiltersActions.LAWS_WAITING_CHANGE_SORT_FILTER:
            return initialState;

        // Plan
        case lawsFiltersActions.LAWS_WAITING_CHANGE_PLAN_FILTER:
            return initialState;

        // Covid filters
        case lawsFiltersActions.APPLY_COVID_FILTERS:
            return initialState;

        // All filters
        case lawsFiltersActions.LAWS_WAITING_REMOVE_ALL_FILTERS:
            return initialState;

        // Switch Feeds
        case activeFeedcActions.SET_ACTIVE_LAWS_FEED_ALL_PUB:
            return initialState;

        case activeFeedcActions.SET_ACTIVE_LAWS_FEED_MY_FAV:
            return initialState;

        case activeFeedcActions.SET_ACTIVE_LAWS_FEED_MY_ACTIONS:
            return initialState;

        case activeFeedcActions.SET_ACTIVE_LAWS_FEED_WAITING_ANSWER:
            return initialState;

        //

        case generalActions.UPDATE_LAWS_AFTER_READ_USERACTION:
            const updatedList =
                state.list &&
                state.list.map((item) => {
                    if (item.id === action.readedArticleId) {
                        return {
                            ...item,
                            read: true,
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedList,
            };

        case generalActions.UPDATE_LAWS_AFTER_RATE_USERACTION:
            const updatedLoadedList =
                state.list &&
                state.list.map((item) => {
                    if (item.id === action.articleId) {
                        return {
                            ...item,
                            user_rating: action.userRating,
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedLoadedList,
            };

        case generalActions.UPDATE_LAWS_AFTER_CHANGE_IMPORTANCE:
            const updatedImportanceList =
                state.list &&
                state.list.map((item) => {
                    if (item.id === action.articleId) {
                        return {
                            ...item,
                            importanceChanged: action.value,
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedImportanceList,
            };

        case generalActions.UPDATE_LAWS_AFTER_CHANGE_ECOSYSTEM_STATE:
            const updatedEcosystemList =
                state.list &&
                state.list.map((item) => {
                    if (item.id === action.articleId) {
                        return {
                            ...item,
                            documents: [
                                {
                                    ...item.documents[0],
                                    ecosystem_comments: action.ecosystemState.ecosystemComments,
                                    ecosystem_status: action.ecosystemState.ecosystemStatus,
                                    ecosystem_modified_date: action.ecosystemState.ecosystemModifiedDate,
                                    ecosystem_favorites: action.ecosystemState.ecosystemFavourites,
                                    ecosystem_pending_favourites: action.ecosystemState.ecosystemPendingFavourites,
                                    ecosystem_recommended_groups: action.ecosystemState.ecosystemRecommendedGroups,
                                },
                                ...item.documents.slice(1),
                            ],
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedEcosystemList,
            };

        case generalActions.UPDATE_LAWS_AFTER_CHANGE_PLAN_STATUS:
            const updatedListCards =
                state.list &&
                state.list.map((item) => {
                    if (item.id === action.articleId) {
                        return {
                            ...item,
                            documents: [
                                {
                                    ...item.documents[0],
                                    rule_making_plan: action.value,
                                },
                                ...item.documents.slice(1),
                            ],
                        };
                    }
                    return item;
                });
            return {
                ...state,
                list: updatedListCards,
            };

        case lawsFiltersActions.LAWS_WAITING_SET_FILTERS:
            return initialState;

        case lawsFiltersActions.LAWS_WAITING_SET_INITIAL_FILTERS:
            return initialState;

        // case lawsActions.ABORT_LAWS_WAITING_REQUEST:
        //   return {
        //     ...state,
        //     isFetching: false,
        //   };

        case lawsActions.CLEAN_LAWS_WAITING:
            return initialState;

        case lawsActions.RESET_LAWS_WAITING_FETCHING:
            return {
                ...state,
                isFetching: false,
            };

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 24+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 28+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsWaiting/reducer.js